<!--
 * @Description: 原物料打印
-->
<template>
  <el-dialog :visible="visible" width="880px" :close-on-click-modal="false" :modal-append-to-body="true" @close="onClose" @open="onOpen">
    <span slot="title" class="dialog-title">查看详情</span>
    <div class="dialoginfo">
      <el-form :inline="true" label-width="110px" :model="config" :disabled="true">
        <div>
          <el-form-item>
            <span slot="label">车牌号：</span>
            <div class="text1" style="width: 280px">
              {{ config.deliveryVehicl }}
            </div>
          </el-form-item>
          <el-form-item>
            <span slot="label">供应商：</span>
            <div class="text1" style="width: 280px">{{ config.supplier }}</div>
          </el-form-item>
          <el-form-item>
            <span slot="label">状态：</span>
            <div class="text1" style="width: 280px">
              {{ config.receiveStatus }}
            </div>
          </el-form-item>
          <el-form-item>
            <!-- <span slot="label">货票量：</span>
              <div style="width: 280px">
                <el-input
                  v-model="config.ticketNum"
                  type="number"
                  @input="calData('ticketNum')"
                ></el-input>
              </div> -->
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <span slot="label">材料名称：</span>
            <div class="text1" style="width: 280px">{{ config.rawName }}</div>
          </el-form-item>
          <el-form-item>
            <span slot="label">材料规格：</span>
            <div class="text1" style="width: 280px">
              {{ config.specification }}
            </div>
          </el-form-item>
        </div>
        <el-form-item>
          <span slot="label">入场时间：</span>
          <div>
            <el-date-picker v-model="config.firstTime" type="datetime" style="width: 280px" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择入场时间"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label">出场时间：</span>
          <div>
            <el-date-picker v-model="config.secondTime" type="datetime" style="width: 280px" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择入场时间"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label">协作单位：</span>
          <div class="text1" style="width: 280px">
            {{ config.cooperativeUnit || "" }}
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label">合同签订主体：</span>
          <div class="text1" style="width: 280px">
            {{ config.contractSigningSubject2 || config.contractSigningSubject || config.contractSigningSubject1 }}
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label">是否甲供：</span>
          <div class="text1" style="width: 280px">
            {{ config.list ? (config.list[0].isFirstSupply === 1 ? "是" : "否") : config.isFirstSupply === 1 ? "是" : "否" }}
          </div>
        </el-form-item>
        <el-form-item v-if="config.list ? config.supplyEngineeringName : config.isFirstSupply === 1">
          <span slot="label">甲供工程：</span>
          <div class="text1" style="width: 280px">
            {{ config.supplyEngineeringName || "" }}
          </div>
        </el-form-item>
        <div class="col">
          <div>
            <el-form-item>
              <span slot="label" style="line-height: 133px">收货量：</span>
              <div class="text1" style="width: 120px; height: 133px">
                {{ config.receiveVolume || 0 }}
              </div>
            </el-form-item>
          </div>
          <div>
            <div>
              <el-form-item>
                <span slot="label">毛重：</span>
                <div class="text1" style="width: 160px">
                  {{ config.firstWeight || 0 }}
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label">含水率(%)：</span>
                <div style="width: 160px">
                  <el-input v-model="config.moistureContent" type="number"></el-input>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <span slot="label">皮重：</span>
                <div class="text1" style="width: 160px">
                  {{ config.secondWeight || 0 }}
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label">含水扣减量：</span>
                <div class="text1" style="width: 160px">
                  {{ Math.round(config.deductionWaterNum * 100) / 100 || 0 }}
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <span slot="label">净重：</span>
                <div class="text1" style="width: 160px">
                  {{ config.netWeight || 0 }}
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label">异常扣减量：</span>
                <div style="width: 160px">
                  <el-input v-model="config.exceptionDeduction" type="number"></el-input>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
        <el-form-item>
          <span slot="label">备注</span>
          <el-input v-model="config.remark" size="medium"></el-input>
          <!-- <div class="text1" style="width:550px">{{config.remark||''}}</div> -->
        </el-form-item>
        <el-form-item prop="factoryTime">
          <span slot="label">出厂时间</span>
          <div style="width: 280px">
            <el-date-picker v-model="config.factoryTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div style="display: flex; justify-content: space-around">
        <div>结算方式：{{ ["", "计量数", "货票数"][config.settleMethod] }}</div>
        <div>货票比例：{{ config.invoiceProportion }}‰</div>
        <div>提示比例：{{ config.noticeProportion }}‰</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      指定打印模板：
      <el-select v-model="printIndex">
        <el-option v-for="(item, index) in printTemplateList" :key="index" :value="item.templateId" :label="item.templateName"></el-option>
      </el-select>
      <span>
        <el-button class="bottom_all" @click="print">打 印</el-button>
      </span>
      <span>
        <el-button class="bottom_all_two" style="margin-left: 24px" @click="onClose">关 闭</el-button>
      </span>
    </span>

    <Printer
      v-if="visible"
      ref="raw-printer"
      :secondKey="'rawSupply'"
      :data="config"
      :userName="userInfo.userRealName"
      :userSelectIndex="printIndex"
      @confList="getPrintTemplate"
      @closeDialog="closeDialog"
    ></Printer>
  </el-dialog>
</template>

<script>
import { getUserInfo } from "@/utils/auth";
import Printer from "@/views/components/Printer.vue";
export default {
  components: { Printer },
  data() {
    return {
      printIndex: "",
      userInfo: "",
      isPrint: false,
    };
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    printTemplateList: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    stationId: {
      type: String,
      default: "",
    },
  },
  watch: {
    printTemplateList(val) {
      if (val) {
        this.getPrintTemplate(val);
      }
    },
  },
  async mounted() {
    this.userInfo = await getUserInfo();
  },
  methods: {
    onOpen() {
      console.log(this.config);
      this.config.receiveVolume = this.config.receiveVolume || 0;
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    closeDialog() {
      this.isPrint = false;
    },
    print() {
      this.isPrint = true;
      this.$nextTick(() => {
        this.$refs["raw-printer"].print();
      });
    },
    getPrintTemplate() {
      let list = this.printTemplateList
      //整理conditionList和模板id
      let conditionDes = [];
      list.forEach(item => {
        let conditionObj = {};
        conditionObj.templateId = item.templateId;
        item.conditionList?.forEach(ite => {
          conditionObj[ite.conditionName] = ite.conditionData;
        });
        conditionDes.push(conditionObj);
      });
      //对比conditionDes和this.config
      let checkSame = condition => {
        let a = condition.find(item => {
          //不考虑["templateId","brand","originPlace","transportUnit"]这些属性是否相同
          let a = Object.keys(item).filter(item => !["templateId", "brand", "originPlace", "transportUnit"].find(ite => item == ite));
          //判断剩下的属性值是否和low的相同
          let sameLength = 0;
          a.forEach(ite => {
            if (ite == "isFirstSupply") {
              let isFirstSupply = this.config[ite] == 1 ? "Y" : "N";
              if (item[ite] === isFirstSupply) {
                sameLength++;
              }
            } else {
              if (item[ite] === this.config[ite]) {
                sameLength++;
              }
            }
          });
          //找出low和condition属性全部相同的哪个对象并返回id
          return sameLength == a.length;
        });
        if (a == undefined) {
          return 0;
        }
        return a.templateId;
      };
      console.log(checkSame(conditionDes))
      if (this.config.templateId) {
        this.printIndex = this.config.templateId;
      } else {
        if (checkSame(conditionDes) != 0) {
          let marryTemplate = this.printTemplateList.find(item => item.templateId == checkSame(conditionDes));
          this.printIndex = marryTemplate.templateId;
          console.log('11111')
        } else {
          this.printIndex = this.printTemplateList[0].templateId;
          console.log('22222')
        }
      }
    },
  },
};
</script>
<style lang="scss">
.receiveNum {
  .el-input__inner {
    width: 133px;
    height: 133px;
  }
}
.col {
  display: flex;
  align-items: center;
}
.text1 {
  border: 1px solid #c3c0bb;
  border-radius: 4px;
  padding: 0 10px;
  display: flex;
  align-items: center;
}
</style>